import React, {memo} from "../../../../../__snowpack__/pkg/react.js";
import styled from "../../../../../__snowpack__/pkg/styled-components.js";
const TableRowWarpHeader = memo((props) => {
  return /* @__PURE__ */ React.createElement(RowHeaderWarp, null, props?.children);
});
const RowHeaderWarp = styled.div`
  height: 32px;
  line-height: 32px;
  background-color: rgb(240, 244, 250);
  display: flex;
`;
const TableRowWarpBody = memo((props) => {
  return /* @__PURE__ */ React.createElement(RowBodyWarp, null, props?.children);
});
const RowBodyWarp = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px 0;
`;
const TableRowWarpItem = memo((props) => {
  return /* @__PURE__ */ React.createElement(RowItemWarp, null, props?.children);
});
const RowItemWarp = styled.div`
  display: flex;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.25);
  padding: 7px 0;
  &:last-child {
    border-bottom: none;
  }
`;
const TextRow = memo((props) => {
  return /* @__PURE__ */ React.createElement(FontRow, {
    style: {maxWidth: props?.maxWidth || 240, ...props?.style}
  }, props?.children);
});
const FontRow = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
export {TableRowWarpHeader, TableRowWarpBody, TableRowWarpItem, TextRow};
